import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AsReportedSecurityBreakdownTags } from "src/api/models";

@Component({
  selector: "app-add-security-tag",
  // imports: [],
  templateUrl: "./add-security-tag.component.html",
  styleUrl: "./add-security-tag.component.css",
  standalone: false,
})
export class AddSecurityTagComponent {
  tagOptions = [
    { label: "is_award_related", key: "awardRelated", disable: false },
    { label: "is_options_related", key: "optionsRelated", disable: false },
    { label: "is_gift_related", key: "giftRelated", disable: false },
    { label: "is_tax_withheld", key: "taxWithheld", disable: false },
    { label: "is_remuneration", key: "remuneration", disable: false },
    { label: "is_indeterminable", key: "isIndeterminable", disable: false },
    { label: "is_sell_to_cover_/_net_settlement", key: "sellToCover", disable: false },

  ];
  selectedTags: any[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.selectedTags = [];

    if (config.data?.existingTags) {
      this.selectedTags = this.tagOptions.filter(
        (option) => config.data.existingTags[option.key] === true
      );
    }
    this.onTagSelection();
  }

  onSave() {
    const tagObj: Partial<AsReportedSecurityBreakdownTags> = {};
    this.tagOptions.forEach((tag) => {
      (tagObj as Record<string, boolean>)[tag.key] =
        this.selectedTags.find((selected) => selected.key === tag.key) !=
        undefined;
    });
      //  FINAL SAFETY: Agar transactionType BUY hai to sellToCover hamesha false

     if (this.config.data?.transactionType === 'BUY') {
    delete (tagObj as any).sellToCover; // ya (tagObj as any).sellToCover = false;
  }
    this.ref.close(tagObj);
  }

  onCancel() {
    this.ref.close();
  }

  // onTagSelection() {
  //   let selection = this.selectedTags;
  //   if (
  //     selection.length === 0 ||
  //     (selection.length === 1 && selection[0].key === "taxWithheld")
  //   ) {
  //     this.tagOptions.forEach((tag) => {
  //       tag.disable = false;
  //     });
  //     return;
  //   }
  //   selection.forEach((value) => {
  //     if (value.key === "remuneration" || value.key === "giftRelated") {
  //       this.selectedTags = [value];
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key) {
  //           tag.disable = true;
  //         }
  //       });
  //     } else if (value.key === "optionsRelated") {
  //       this.selectedTags = this.selectedTags.filter(
  //         (tag) => tag.key !== "awardRelated"
  //       );
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key && tag.key === "awardRelated") {
  //           tag.disable = true;
  //         }
  //       });
  //     } else if (value.key === "awardRelated") {
  //       this.selectedTags = this.selectedTags.filter(
  //         (tag) => tag.key !== "optionsRelated"
  //       );
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key && tag.key === "optionsRelated") {
  //           tag.disable = true;
  //         }
  //       });
  //     }
  //   });
  // }
  onTagSelection() {
  let selection = this.selectedTags;

  // Sab ko pehle enable kar do
  this.tagOptions.forEach((tag) => (tag.disable = false));

  // --- existing rules ---
  if (
    selection.length === 0 ||
    (selection.length === 1 && selection[0].key === "taxWithheld")
  ) {
    // yahan se abhi return na karo, kyun ke neeche BUY rule lagana hai
  } else {
    selection.forEach((value) => {
      if (value.key === "remuneration" || value.key === "giftRelated") {
        this.selectedTags = [value];
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key) {
            tag.disable = true;
          }
        });
      } else if (value.key === "optionsRelated") {
        this.selectedTags = this.selectedTags.filter(
          (tag) => tag.key !== "awardRelated"
        );
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key && tag.key === "awardRelated") {
            tag.disable = true;
          }
        });
      } else if (value.key === "awardRelated") {
        this.selectedTags = this.selectedTags.filter(
          (tag) => tag.key !== "optionsRelated"
        );
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key && tag.key === "optionsRelated") {
            tag.disable = true;
          }
        });
      }
    });
  }

  // --- NEW RULE: Agar transactionType BUY hai to sellToCover disable + unselect ---
  const txType = this.config.data?.transactionType;

  if (txType === 'BUY') {
    // option disable
    const sellToCover = this.tagOptions.find(
      (t) => t.key === 'sellToCover'
    );
    if (sellToCover) {
      sellToCover.disable = true;
    }

    // agar pehle se selected hai to unselect kar do
    this.selectedTags = this.selectedTags.filter(
      (t) => t.key !== 'sellToCover'
    );
  }
}

}
